import {ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, ParamMap, Router} from "@angular/router";
import {IRouteInfo} from "../../../services/component/navigation/navigation.service";
import {BaseComponentAbstract} from "../../../../class/base.component.abstract";
import {DomSanitizer} from "@angular/platform-browser";
import {FilterDataService, FilterCode, FilterType, FilterGroup} from "../../../services/component/news-page/filter-data.service";
import {DmsNewsListResponseSchema} from "../../../model/dmsNewsListResponseSchema";
import {BreakpointObserver, BreakpointState} from "@angular/cdk/layout";
import {MatDialog} from "@angular/material/dialog";
import {DialogNewWfTaskBoxComponent} from "../../shared/dialog-new-wf-task-box/dialog-new-wf-task-box.component";
import {DialogNewTaskBoxComponent} from "../../shared/dialog-new-task-box/dialog-new-task-box.component";
import {debounceTime, Subject} from "rxjs";
import {PrevPageService} from "../../../services/component/navigation/prev-page.service";
import {DmsNewsItem} from "../../../model/dmsNewsItem";
import {MatSidenav} from "@angular/material/sidenav";
import {DmsWfTaskResultItem} from "../../../model/dmsWfTaskResultItem";
import {tabIndexMap} from "./details-sidenav/details-sidenav.component";
import {MatSnackBar} from "@angular/material/snack-bar";
import {DialogWfDetailsBoxComponent} from "../../shared/dialog-wf-details-box/dialog-wf-details-box.component";
import {DmsWfTasksService} from "../../../services/api/dms-wf-tasks.service";
import { PrevOpenedTaskService } from 'src/app/services/component/navigation/prev-opened-task.service';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    standalone: false
})
export class DashboardComponent extends BaseComponentAbstract implements OnInit{

  @ViewChild('sidenav') sidenav!: MatSidenav;

  refreshTime!: string;

  originalNewsData: DmsNewsListResponseSchema = [];
  sortedAndFilteredNewsData: DmsNewsListResponseSchema = [];

  sidenavData: {
    newsItem: DmsNewsItem,
    tabNum: number,
    backdropClicked?: boolean,
  } | null = null;

  searchValue = '';

  isSmallScreen: boolean = false;
  isSmallToolbar: boolean = false;
  showFilters: boolean = false;

  searchSubject = new Subject<string>();

  showCards = true;

  filters: FilterGroup[];

  sortOptions = [
    {code: 'deadlin-asc', displayName: 'SORT_DEADLINE_ASC', selected: false}, //property: item.taskDeadline - string (date) //Határidő szerint növekvő
    {code: 'deadline-desc', displayName: 'SORT_DEADLINE_DESC', selected: false}, //property: item.taskDeadline - string (date) //Határidő szerint csökkenő
    {code: 'abc-asc', displayName: 'SORT_ABC_ASC', selected: false}, //property: item.subject - string //Név szerint növekvő
    {code: 'abc-desc', displayName: 'SORT_ABC_DESC', selected: false}, //property: item.subject - string //Név szerint csökkenő
    {code: 'create-desc', displayName: 'SORT_CREATE_DESC', selected: true}, //property: item.taskStart - string (date) //Létrehozás szerint csökkenő
    {code: 'create-asc', displayName: 'SORT_CREATE_ASC', selected: false}, //property: item.taskStart - string (date) //Létrehozás szerint növekvő
  ]

  sortOrder: string[] = ['create-desc'];

  listStyle: string = 'list';

  constructor(
    route: ActivatedRoute,
    router: Router,
    public sanitizer: DomSanitizer,
    private breakpointObserver: BreakpointObserver,
    private cdr: ChangeDetectorRef,
    private filterDataService: FilterDataService,
    public dialog: MatDialog,
    private prevPageService: PrevPageService,
    private snackBar: MatSnackBar,
    private workflowItemService: DmsWfTasksService,
    public prevOpenedTaskService: PrevOpenedTaskService,
  ){
    super(route, router);
    this.setRefreshTime();
    this.filters = [
      {
        code: FilterType.TYPE,
        name: 'FILTER_TYPE_LABEL',
        selected: FilterCode.ALL,
        subFilters: [
          { code: FilterCode.WORKFLOW, name: 'WORKFLOW' },
          { code: FilterCode.TASK, name: 'TASK_CHECK' },
          { code: FilterCode.ALL, name: 'ALL_TYPES' }
        ]
      },
      {
        code: FilterType.STATUS,
        name: 'STATUS',
        selected: FilterCode.IN_PROGRESS,
        subFilters: [
          { code: FilterCode.IN_PROGRESS, name: 'IN_PROGRESS' },
          { code: FilterCode.DRAFT, name: 'DRAFT_FILTER' },
          { code: FilterCode.CLOSED, name: 'CLOSED_FILTER' },
          { code: FilterCode.ALL, name: 'ALL_STATUSES' }
        ]
      },
      {
        code: FilterType.OTHER,
        name: 'OTHER_FILTERS',
        selected: FilterCode.ALL,
        subFilters: [
          { code: FilterCode.FAVORITES, name: 'FAVOURITES_ONLY' },
          { code: FilterCode.ALL, name: 'NO_FILTER' }
        ]
      }
    ];
  }

  override ngOnInit() {
    super.ngOnInit();
    this.originalNewsData = this.requestData.allIncomingDataNews
    this.sortedAndFilteredNewsData = this.originalNewsData;
    this.filterNewsItems();
    this.sortNewsItems();
    this.breakpointObserver.observe([
      "(max-width: 1023px)",
      "(max-width: 768px)"
    ]).subscribe((result: BreakpointState) => {
      this.isSmallScreen = result.breakpoints['(max-width: 1023px)'];
      this.isSmallToolbar = result.breakpoints['(max-width: 768px)'];
      this.cdr.detectChanges();
    })
    this.searchSubject.pipe(debounceTime(200)).subscribe(() => {
      this.sortAndFilterNewsData();
    });
    if (this.prevOpenedTaskService.prevOpenedTaskId) {
      const prevItem = this.originalNewsData.find(item => item.id === this.prevOpenedTaskService.prevOpenedTaskId);
      if (prevItem) {
        this.openDetails({item: prevItem, tab: 'details'});
        this.prevOpenedTaskService.setPrevOpenedTaskId(null);
      }
    }
  }

  setRefreshTime(): void {
    const now = new Date();
    const year = now.getFullYear();
    const month = (now.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-based
    const day = now.getDate().toString().padStart(2, '0');
    const hours = now.getHours().toString().padStart(2, '0');
    const minutes = now.getMinutes().toString().padStart(2, '0');

    this.refreshTime = `${hours}:${minutes} ${year}.${month}.${day}`;
  }

  public setupNavigation(params: ParamMap): IRouteInfo {
    return {
      header: '', actions: [/*{
        icon: 'supervisor_account',
        click: () => {
          this.router.navigate(['admin-dashboard']);
        },
        caption: 'Admin page',
        tooltip: 'Admin page'
      }*/]
    };
  }

  private reloadPage(){
    this.router.navigate(['/pageloading']);
  }

  onNewTask() {
    const dialogRef = this.dialog.open(DialogNewTaskBoxComponent, {
      autoFocus: false,
      closeOnNavigation: true
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result){
        this.reloadPage();
      }
    });
  }

  onNewWfTask() {
    const dialogRef = this.dialog.open(DialogNewWfTaskBoxComponent, {
      autoFocus: false,
      closeOnNavigation: true
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result){
        this.reloadPage();
      }
    });
  }

  isTaskListEmpty(){
    return (!this.sortedAndFilteredNewsData || this.sortedAndFilteredNewsData.length === 0);
}

  /* scrollDown() {
    setTimeout(() => {
      this.prevPageService.triggerScroll();
    });
  } */

  openDetails(data: {item: DmsNewsItem, tab:string}){
    const tabNum = tabIndexMap[data.tab] ?? 0;
    const newData = {
      newsItem: data.item,
      tabNum: tabNum,
    };
    this.sidenavData = null;
    setTimeout(() => {
      this.sidenavData = newData;
      this.sidenav.open();
    });
  }
  closeDetails(data: {
    refreshPage: boolean,
    itemType?: DmsNewsItem.TypeEnum,
    itemId?: number,
    selectedResult?: DmsWfTaskResultItem | undefined }){
    if(data.refreshPage){
      setTimeout(() => {
        this.reloadPage();
      });
    } else {
      // this.showCards=false;
      if (data.selectedResult) {
        const item = this.sortedAndFilteredNewsData.find(d => d.id === data.itemId && d.type === data.itemType);
        if (!item || !item.possibleResults) return;
        for (const result of item.possibleResults) {
          result.isSelected = result.id === data.selectedResult.id;
        }
      }
      setTimeout(() => {
        this.showCards = true;
        this.sidenav.close();
        this.sidenavData = null;
      });
    }
  }

  onSearchInput() {
    this.searchSubject.next(this.searchValue);
  }

  sortAndFilterNewsData() {
    setTimeout(() => {
      this.sortedAndFilteredNewsData = this.originalNewsData;
      this.filterNewsItems();
      this.filterNewsItemsWithText();
      this.sortNewsItems();
    });
  }

  filterNewsItems() {
    const selectedType = this.filters.find(f => f.code === FilterType.TYPE)?.selected;
    if (selectedType === FilterCode.WORKFLOW) this.sortedAndFilteredNewsData = this.sortedAndFilteredNewsData.filter(item => item.type === 'WfTask');
    else if (selectedType === FilterCode.TASK) this.sortedAndFilteredNewsData = this.sortedAndFilteredNewsData.filter(item => item.type === 'Task');

    const selectedStatus = this.filters.find(f => f.code === FilterType.STATUS)?.selected;
    if (selectedStatus === FilterCode.IN_PROGRESS) this.sortedAndFilteredNewsData = this.sortedAndFilteredNewsData.filter(item => this.isActiveStatus(item));
    else if (selectedStatus === FilterCode.DRAFT) this.sortedAndFilteredNewsData = this.sortedAndFilteredNewsData.filter(item => this.isDraftStatus(item));
    else if (selectedStatus === FilterCode.CLOSED) this.sortedAndFilteredNewsData = this.sortedAndFilteredNewsData.filter(item => !this.isActiveStatus(item) && !this.isDraftStatus(item));

    const selectedOther = this.filters.find(f => f.code === FilterType.OTHER)?.selected;
    if (selectedOther === FilterCode.FAVORITES) this.sortedAndFilteredNewsData = this.sortedAndFilteredNewsData.filter(item => item.isFavorite);
  }

  filterNewsItemsWithText() {
    if (!this.searchValue || this.searchValue.trim().length < 1) return;
    let filteredItems = this.sortedAndFilteredNewsData;
    const lowerCaseSearchTerm = this.searchValue.toLowerCase();
    const strippedSearchTerm = lowerCaseSearchTerm.startsWith('#') ?
      lowerCaseSearchTerm.substring(1) : lowerCaseSearchTerm; //if user searches for reference number
    filteredItems = filteredItems.filter(item => {
      return (
        (item.subject && item.subject.toLowerCase().includes(lowerCaseSearchTerm)) ||
        (item.status && item.status.toLowerCase().includes(lowerCaseSearchTerm)) ||
        (item.taskStart && item.taskStart.toLowerCase().includes(lowerCaseSearchTerm)) ||
        (item.taskDeadline && item.taskDeadline.toLowerCase().includes(lowerCaseSearchTerm)) ||
        (item.taskName && item.taskName.toLowerCase().includes(lowerCaseSearchTerm)) ||
        (item.referenceNumber && item.referenceNumber.toLowerCase().includes(strippedSearchTerm)) ||
        (item.wfDescription && item.wfDescription.toLowerCase().includes(lowerCaseSearchTerm)) ||
        (item.taskDescription && item.taskDescription.toLowerCase().includes(lowerCaseSearchTerm)) ||
        (item.result && item.result.toLowerCase().includes(lowerCaseSearchTerm))
      );
    });
    this.sortedAndFilteredNewsData = filteredItems;
  }

  changeSortingMethod(code: string){
    this.sortOptions.forEach(option => {
      option.selected = option.code === code;
    });
    this.sortAndFilterNewsData();
  }

  sortNewsItems() {
    this.sortOrder = this.sortOrder.length > 0 ? [this.sortOrder[0]] : ['create-desc'];
    this.sortedAndFilteredNewsData = this.sortedAndFilteredNewsData.sort((a, b) => {
      switch(this.sortOrder[0]) {
        case 'create-desc':
          if (!b.taskStart) return 1;
          if (!a.taskStart) return -1;
          return new Date(b.taskStart.replace(' ', 'T')).getTime() - new Date(a.taskStart.replace(' ', 'T')).getTime();
        case 'create-asc':
          if (!a.taskStart) return 1;
          if (!b.taskStart) return -1;
          return new Date(a.taskStart.replace(' ', 'T')).getTime() - new Date(b.taskStart.replace(' ', 'T')).getTime();
        case 'deadline-desc':
          if (!a.taskDeadline) return 1;
          if (!b.taskDeadline) return -1;
          return new Date(b.taskDeadline.replace(' ', 'T')).getTime() - new Date(a.taskDeadline.replace(' ', 'T')).getTime();
        case 'deadlin-asc':
          if (!a.taskDeadline) return 1;
          if (!b.taskDeadline) return -1;
          return new Date(a.taskDeadline.replace(' ', 'T')).getTime() - new Date(b.taskDeadline.replace(' ', 'T')).getTime();
        case 'abc-desc':
          return (b.subject || '').localeCompare((a.subject || ''), 'hu');
        case 'abc-asc':
          return (a.subject || '').localeCompare((b.subject || ''), 'hu');

        default:
          return 0;
      }
    });
  }

  onDetails(id: number){
    this.workflowItemService.readDmsWfTaskById$(id).subscribe( response => {
      if(response&&response.result){
        this.dialog.open(DialogWfDetailsBoxComponent, {
          data: {
            wfTaskDetails: response.result,
            wfDetails: response.result.wfDetails,
          },
          autoFocus: false,
        })
      }
    })
  }

  backdropClose(){
    if (this.sidenavData) {
      this.sidenavData = {
        ...this.sidenavData,
        backdropClicked: true
      };
    }
  }

  private isActiveStatus(item: DmsNewsItem){
    if (this.isDraftStatus(item)) return false;
    return item.status === '1_elfogadva' || item.status === '1_letrehozva' || item.status === 'FA_U';
  }

  private isDraftStatus(item: DmsNewsItem){
    return item.type === 'Task' && item.taskStatus === 'Draft';
  }

  // starFiltering(){
  //   this.sortedNewsData = [];
  //   this.sortedNewsData = this.filterNewsItems(this.originalNewsData, '');
  // }
}
